<template>
  <div>
    <div
        :class="{
        completed:
          estatePlanningProgress.filter((c) => c.percentage === 100).length ===
          estatePlanningProgress.length,
      }"
        class="d-flex align-items-center page-num-container pt-80"
    >
      <div class="page-num"></div>
      <h4>Estate Planning Questions</h4>
    </div>
    <b-row>
      <b-col lg="7">
        <p class="mb-lg-32">
          The below {{ estatePlanningProgress.length > 1 ? "questionnaires" : "questionnaire" }} contains various questions
          about your health, estate planning priorities and current arrangements.
        </p></b-col
      >
    </b-row>

    <b-row class="pt-20">
      <b-col
          v-for="(estatePlanning, index) in estatePlanningProgress"
          :key="`estatePlanning${index}`"
          md="4"
      >
        <EstatePlanningSurveyCard
            v-if="user"
            :progress="estatePlanning"
            :disabled="estatePlanning.client.id !== user.is_client.id"
            :transaction="transaction"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import EstatePlanningSurveyCard from "../estatePlanning/cards/EstatePlanningSurvey";

export default {
  name: "EstatePlanning",
  components: { EstatePlanningSurveyCard },
  props: {
    estatePlanningProgress: {
      type: Array,
      required: true,
    },
    transaction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>
